exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-page__order-block-btn[data-v-399a8080]{\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
